<template>
  <div>
    <b-row align="left">
      <b-col md="6" class="mt-2">
        <p class="mb-1 font-weight-bold">
          <font class="h4 text-primary">Food Service</font>
          &nbsp;&nbsp;&nbsp;
          <font class="h5 text-warning border rounded p-1">{{tanggal}}</font>
        </p>
      </b-col>
      <b-col>
        <b-row>
          <b-col md="4"></b-col>
          <b-col>
            <b-row align="right" class="text-right">
              <b-col></b-col>
              <b-col md="6" align="right" class="text-right">
                <b-input-group class="text-right">
                  <b-input-group-text class="bg-white border-right-0" slot="prepend">
                    <img src="@/assets/filter.svg" alt />
                  </b-input-group-text>
                  <b-dropdown
                    text="Filter Data"
                    variant="light"
                    toggle-class="bg-white border-secondary text-primary border-left-0 pl-0"
                    slot="append"
                  >
                    <b-dropdown-item @click="cxFilter('claim')">
                      <span class="text-danger">Klaim</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="cxFilter('completed')">
                      <span class="text-info">Informasi</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="cxFilter('information')">
                      <span class="text-warning">Komplain</span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="cxFilter('feedback')">
                      <span class="text-primary">Masukan</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-input-group>
              </b-col>
              <b-col md="5" align="right" class="text-right">
                <download-csv class="d-none" :data="CSV" name="tickets.csv" ref="DownloadCSV"></download-csv>
                <b-button class="btn btn-primary" :disabled="loadingCSV" @click="downloadCSV()">
                  <b-spinner label="Spinning" v-show="loadingCSV"></b-spinner>Export to CSV
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <br />
    <b-card body-class="py-0 px-0">
      <b-row>
        <b-col md="4" class="border-right text-left pl-5 py-5">
          <b-row>
            <b-col>
              <h5 class>Total Tiket</h5>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <h4 class="mb-0" v-else>{{ items ? items.total_ticket:items}}</h4>
            </b-col>
            <b-col md="8">
              <b-row>
                <b-col md="9">
                  <b-form-group id="fieldset-1" label="Filter Tanggal" label-for="input-1">
                    <b-row class="m-0">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="4"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 "
                          placeholder="From"
                          v-model="date_from"
                          :format="customFormatter"
                          @input="cxDate()"
                          :disabledDates="element2"
                        ></datepicker>
                      </b-col>
                      <!-- <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetFromdate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>-->
                    </b-row>
                    <b-row class="m-0 mt-2">
                      <b-col
                        class="pr-0 pt-1 form-control img-calender-select border-right-0"
                        md="4"
                      >
                        <img src="@/assets/ic-calendar-copy-30.svg" width="25px" alt class />
                      </b-col>
                      <b-col class="px-0">
                        <datepicker
                          input-class="form-control text-dark pl-0 bg-white calender-select border-left-0 "
                          placeholder="To"
                          v-model="date_to"
                          @input="cxDate()"
                          :format="customFormatter"
                          :disabledDates="element"
                        ></datepicker>
                      </b-col>
                      <!-- <b-col align="left" md="1" class="px-0">
                        <b-col
                          align="left"
                          class="pt-1 px-4 form-control del-calender-select border-left-0"
                          md="2"
                        >
                          <b-row align="left" class="pt-1">
                            <b-col>
                              <b-link @click="resetTodate" style="text-decoration:none">
                                <i class="text-danger fas fa-times"></i>
                              </b-link>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>-->
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <b-col>
            <p class="text-warning font-weight-bold mb-0">Komplain</p>
            <b-row>
              <b-col class="font-weight-bold">
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_complaint.total:items}}</p>
              </b-col>
              <b-col>
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_complaint.percentage.toFixed(2):items}}%</p>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <p class="text-warning font-weight-bold mb-0">Submitted</p>
            <b-row>
              <b-col class="font-weight-bold">
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.sla_claim.submitted:items}}</p>
              </b-col>
              <!-- <b-col>
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_complaint.percentage.toFixed(2):items}}%</p>
              </b-col> -->
            </b-row>
          </b-col>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <b-col>
            <p class="text-danger font-weight-bold mb-0">Klaim</p>
            <b-row>
              <b-col class="font-weight-bold">
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_claim.total:items}}</p>
              </b-col>
              <b-col>
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_claim.percentage.toFixed(2):items}}</p>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <p class="text-primary font-weight-bold mb-0">Risk Late</p>
            <b-row>
              <b-col class="font-weight-bold">
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.sla_claim.risk_late:items}}</p>
              </b-col>
              <!-- <b-col>
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_claim.percentage.toFixed(2):items}}</p>
              </b-col> -->
            </b-row>
          </b-col>
        </b-col>
        <b-col class="border-right text-left pl-4 py-5">
          <b-col>
            <p class="text-info font-weight-bold mb-0">Informasi</p>
            <b-row>
              <b-col class="font-weight-bold">
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_information.total:items}}</p>
              </b-col>
              <b-col>
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_information.percentage.toFixed(2):items}}</p>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <p class="text-danger font-weight-bold mb-0">Late</p>
            <b-row>
              <b-col class="font-weight-bold">
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.sla_claim.late:items}}</p>
              </b-col>
              <!-- <b-col>
                <b-spinner v-if="loading" label="Loading..."></b-spinner>
                <p v-else>{{items ? items.total_information.percentage.toFixed(2):items}}</p>
              </b-col> -->
            </b-row>
          </b-col>
        </b-col>
        <b-col class="text-left pl-4 py-5">
          <p class="text-primary font-weight-bold mb-0">Masukan</p>
          <b-row>
            <b-col class="font-weight-bold">
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>{{items ? items.total_feedback.total:items}}</p>
            </b-col>
            <b-col>
              <b-spinner v-if="loading" label="Loading..."></b-spinner>
              <p v-else>{{items ? items.total_feedback.percentage.toFixed(2):items}}%</p>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <br />
    <div class="text-left">
      <b-row>
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1 text-right" align="right">
          <!-- <div>
            <b-button 
                variant="primary"
                :disabled="selected.length === 0"
                :class="'text-default'"
                @click="changeType()"
                href="#"
            >
              <img src="@/assets/ic-status.svg" alt class="mr-2" /> Transfer to CE
            </b-button>
          </div> -->
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        ref="cxContent"
        hover
        :items="getInfo"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(time_issued)="row">{{row.value.substring(0,10)}}</template>
        <template v-slot:cell(message)="row">{{row.value.substring(0,20)}}....</template>
        <!-- <template v-slot:head(selected)="row">
          <span class="text-info">
            <b-form-checkbox
              v-model="allSelected"
              :indeterminate="indeterminate"
              aria-describedby="items"
              aria-controls="items"
              @change="toggleAll"
            ></b-form-checkbox>
          </span>
        </template> -->
        <!-- <template v-slot:cell(selected)="{ rowSelected, item, index }">
          <template v-if="rowSelected">
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_true"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">
              <b-form-checkbox
                id="checkbox-1"
                v-model="selected_field_false"
                name="checkbox-1"
                value="true"
                class="pointer-off"
                unchecked-value="false"
              ></b-form-checkbox>
            </span>
            <span class="sr-only">Not selected</span>
          </template>
        </template> -->
        <template v-slot:cell(type)="row">
          <p class="text-warning" v-if="row.value == 'complaint'">Komplain</p>
          <p class="text-danger" v-else-if="row.value == 'claim'">Klaim</p>
          <p class="text-info" v-else-if="row.value == 'information'">Informasi</p>
          <p class="text-primary" v-else-if="row.value == 'feedback'">Masukan</p>
        </template>
        <template v-slot:cell(status)="row">
          <p class="text-warning" v-if="row.value == 'submitted'">Submitted</p>
          <p class="text-danger" v-else-if="row.value == 'rejected'">Rejected</p>
          <p class="text-info" v-else-if="row.value == 'on_review'">On Review</p>
          <p class="text-primary" v-else-if="row.value == 'refunded'">Refunded</p>
        </template>
        <template v-slot:cell(document_total)="row">
          <p>{{row.value}}/5</p>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            v-if="item.type == 'claim'"
            :to="{name: 'cxDetailFoodClaim', params: {id: item.id}}"
            class="text-primary"
            v-b-tooltip.hover
            title="View Detail"
          >
            <i class="fas fa-eye"></i>
          </router-link>
          <router-link
            v-else-if="item.type == 'information'"
            :to="{name: 'cxDetailInformationFoodClaim', params: {id: item.id}}"
            class="text-primary"
            v-b-tooltip.hover
            title="View Detail"
          >
            <i class="fas fa-eye"></i>
          </router-link>
          <router-link
            v-else-if="item.type == 'feedback'"
            :to="{name: 'cxDetailFeedbackFoodClaim', params: {id: item.id}}"
            class="text-primary"
            v-b-tooltip.hover
            title="View Detail"
          >
            <i class="fas fa-eye"></i>
          </router-link>
          <router-link
            v-else-if="item.type == 'complaint'"
            :to="{name: 'cxDetailComplaintFoodClaim', params: {id: item.id}}"
            class="text-primary"
            v-b-tooltip.hover
            title="View Detail"
          >
            <i class="fas fa-eye"></i>
          </router-link>
        </template>
      </b-table>

      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      modalShow: false,
      loading: true,
      errored: false,
      // selected_field_true: true,
      // selected_field_false: false,
      items: [],
      // selectMode: "multi",
      // selected: [],
      // allSelected: false,
      indeterminate: false,
      fields: [
        // {
        //   key: "selected",
        //   class: "text-center w-5"
        // },
        {
          key: "type",
          label: "Tipe",
          sortable: true,
          class: "text-center",
        },
        {
          key: "time_issued",
          label: "Tanggal Pengajuan",
          sortable: true,
          class: "text-center",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          class: "text-center",
        },
        {
          key: "shipment_code",
          label: "No Resi/AWB",
          sortable: true,
          class: "text-center",
        },
        {
          key: "ticket_no",
          label: "No Tiket",
          sortable: true,
          class: "text-center",
        },

        {
          key: "name",
          label: "Nama",
          class: "text-center",
        },
        {
          key: "approval.status",
          label: "Persetujuan",
          class: "text-center",
        },
        {
          key: "document_total",
          label: "Kelengkapan Dokumen",
          class: "text-center",
        },

        { key: "action", label: "Action", class: "text-center" },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      cx_type: "",
      cx_disbursement_type: "FOOD_CLAIM",
      date_from: new Date(new Date().setDate(new Date().getDate() - 30)),
      date_to: new Date(Date.now()),
      loadingCSV: false,
      CSV: [],
      tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, "/"),
      routename: null,
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
    };
  },
  watch: {
    element: {
      handler: function (newValue) {
        if (newValue) {
          this.element = newValue;
        }
      },
      deep: true,
    },
    element2: {
      handler: function (newValue) {
        if (newValue) {
          this.element2 = newValue;
        }
      },
      deep: true,
    },
    // selected(newVal, oldVal) {
    //   if (newVal.length === 0) {
    //     this.indeterminate = false;
    //     this.allSelected = false;
    //   } else if (newVal.length === this.items.length) {
    //     this.indeterminate = false;
    //     this.allSelected = true;
    //   } else {
    //     this.indeterminate = true;
    //     this.allSelected = false;
    //   }
    // }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
    element() {
      var disabledDates = {
        to: new Date(this.date_from - 8640000),
      };
      return disabledDates;
    },
    element2() {
      var disabledDates = {
        from: new Date(this.date_to + 8640000),
      };
      return disabledDates;
    },
  },
  beforeCreate() {
    // this.$store.dispatch("getDonatur");
    // this.$store
    //   .dispatch("cxModule/getCxReports")
    //   .then(response => {
    //     this.loading = false;
    //   })
    //   .catch(error => {
    //     this.$swal({
    //       type: "error",
    //       title: "Oops...",
    //       text: error.response.data.message,
    //       showConfirmButton: false,
    //       timer: 1500
    //     });
    //     this.loading = false;
    //   });
  },
  created() {
    // Set the initial number of items
    // this.totalRows = this.items.length;
    // this.$store.watch(
    //   state => state.cxModule.report,
    //   (newValue, oldValue) => {
    //     this.items = newValue;
    //   }
    // );
  },
  methods: {
    downloadCSV() {
      this.$swal({
        title: "Download CSV Report??",
        text: "Proses ini akan memakan waktu dan beban pada database",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ya!",
        cancelButtonText: "Tidak",
      }).then((result) => {
        if (result.value) {
          this.loadingCSV = true;
          const formData = new FormData();
          formData.append("search_param", "");
          formData.append("limit", "");
          formData.append("page", "");
          formData.append("sort_by", "created_time");
          formData.append("is_sort_asc", false);
          formData.append("type", this.cx_type);
          formData.append("disbursement_type", this.cx_disbursement_type);
          formData.append(
            "date_from",
            this.date_from ? moment(this.date_from).format("YYYY-MM-DD") : ""
          );
          formData.append(
            "date_to",
            this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : ""
          );
          this.$store
            .dispatch("cxModule/getCxCSV", formData)
            .then((response) => {
              this.CSV = response.data.data.results.tickets;
              setTimeout(() => {
                this.loadingCSV = false;
                this.$refs.DownloadCSV.$el.click();
              }, 1000);
            })
            .catch((error) => {
              this.loadingCSV = false;
              callback([]);
            });
        } else {
        }
      });
    },
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    cxFilter(payload) {
      this.cx_type = payload;
      this.$refs.cxContent.refresh();
    },
    cxDate() {
      if (this.date_to < this.date_from) {
        this.$swal({
          title: "Tanggal tidak sesuai!",
          type: "error",
          showConfirmButton: false,
          timer: 1000,
        });
      } else {
        this.$refs.cxContent.refresh();
      }
    },
    resetFromdate() {
      this.date_from = "";
      this.$refs.cxContent.refresh();
    },
    resetTodate() {
      this.date_to = "";
      this.$refs.cxContent.refresh();
    },
    getInfo(ctx, callback) {
      this.loading = true;
      const vm = this;
      const formData = new FormData();

      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", ctx.sortDesc);
      formData.append("type", this.cx_type);
      formData.append("disbursement_type", this.cx_disbursement_type);
      formData.append(
        "date_from",
        this.date_from ? moment(this.date_from).format("YYYY-MM-DD") : ""
      );
      formData.append(
        "date_to",
        this.date_to ? moment(this.date_to).format("YYYY-MM-DD") : ""
      );
      this.$store
        .dispatch("cxModule/getCxReports", formData)
        .then((response) => {
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results.tickets || []);
          this.loading = false;
          this.items = response.data.data.results;
        })
        .catch((error) => {
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
    date() {
      const currentDateWithFormat = "";
      this.tanggal = currentDateWithFormat;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // toggleAll(checked) {
    //   this.selected = checked
    //     ? this.$refs.cxContent.selectAllRows()
    //     : this.$refs.cxContent.clearSelected();
    // },
    // onRowSelected(items) {
    //   this.selected = items;
    // },
    // changeType() {
    //   this.$swal({
    //     title: "Are you sure?",
    //     text: `You will transfer this Auto Klaim to Customer Empathy!`,
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Yes, transfer it!"
    //   }).then(result => {
    //     if (result.value) {
    //       this.$swal({
    //         title: "Transfering...",
    //         text: "Please wait",
    //         imageUrl: "/img/loader_3_dots.gif",
    //         imageHeight: 100,
    //         showConfirmButton: false,
    //         allowOutsideClick: false
    //       });

    //       var selected = {ids: []};

    //       $.each(this.selected, (key, value) => {
    //         selected.ids.push(value.id);  
    //       });

    //       this.$store
    //         .dispatch("cxFoodClaim/putCxTransferToCE", selected)
    //         .then(response => {
    //           this.loading = false;
    //           this.$refs.cxContent.refresh();
    //           this.$swal({
    //             type: "success",
    //             title: "Transfer has been completed!",
    //             showConfirmButton: false,
    //             timer: 1000
    //           });
    //           console.log(response);
    //         })
    //         .catch(error => {
    //           this.loading = false;
    //           this.$swal(error.response.data.message);
    //           this.serverError = error.response;
    //           console.log(error);
    //         });
    //     }
    //   });

    //   // console.log(list);
    // },
    // toggleAll(checked) {
    //   this.selected = checked
    //     ? this.$refs.cxContent.selectAllRows()
    //     : this.$refs.cxContent.clearSelected();
    // }
  },
};
</script>

<style scoped>
.pointer-off {
  pointer-events: none;
}
.title {
  width: 120px;
}
</style>
